import { Button } from "@material-tailwind/react";
import { Link } from "react-router-dom";

type Props = {
  message?: string
  code?: number
}
const NotFound = ({
  message = "Page not found",
  code = 404
}:Props) => {
  return (
    <div className="w-full min-h-screen flex items-center justify-center flex-col relative">
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-[#000000aa] to-[#00000000]"></div>
      <h1 className="text-5xl font-bold">{code}</h1>
      <p className="mb-3">{message}</p>
      <Link to={"/"}>
        <Button>
          Back To Home
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;